var map = {
	"./choose-1.png": 8782,
	"./choose-2.png": 9141,
	"./choose-3.png": 6252,
	"./choose-4.png": 1123,
	"./choose-5.png": 2266,
	"./choose-6.png": 6497
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5033;